import { useQuery } from "react-query";
import { fetchOneActivityById } from "api/CpdApi";
import { activityQueryKeys } from "queries/constants";
import { QueryOptions } from "queries/queries";
import { useToast } from "components/common/ui/toast/useToast";

export const useActivityDetail = (
  activityId: string,
  userId?: string,
  options?: QueryOptions
) => {
  const { addErrorToast } = useToast();
  return useQuery(
    activityQueryKeys.detail(activityId),
    () => fetchOneActivityById(activityId, userId),
    {
      onError: (e) =>
        addErrorToast(e, "Unable to load activity details", {
          id: activityQueryKeys.detail(activityId).join("::"),
        }),
      ...options,
    }
  );
};
